import { Box, styled } from '@mui/material';

export const StyledContainer = styled(Box)(({ theme }) => ({
  width: theme.spacing(18.75),
  margin: theme.spacing(6, 4, 6),
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(5, 0, 2),
  },
}));
